import { render, staticRenderFns } from "./seurantakeskustelut-card.vue?vue&type=template&id=454aa29a&scoped=true&"
import script from "./seurantakeskustelut-card.vue?vue&type=script&lang=ts&"
export * from "./seurantakeskustelut-card.vue?vue&type=script&lang=ts&"
import style0 from "./seurantakeskustelut-card.vue?vue&type=style&index=0&id=454aa29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454aa29a",
  null
  
)

export default component.exports